import { computed, ref, unref, watch } from 'vue';
import RealEstateBrokerCommissionsAPI from 'dashboard/api/realEstateBrokerCommissions';

export function useRealEstateBrokerCommissionDetail({
  installmentId,
  notify,
  t,
} = {}) {
  const detail = ref(null);
  const loading = ref(false);
  const error = ref('');

  const load = async () => {
    const id = unref(installmentId);
    if (!id) return;
    loading.value = true;
    error.value = '';
    try {
      const response = await RealEstateBrokerCommissionsAPI.detail(id);
      detail.value = response.data.data;
    } catch (loadError) {
      error.value = t('REAL_ESTATE_BROKER_COMMISSION.ERRORS.LOAD');
      if (notify) notify(error.value, null, { variant: 'error' });
    } finally {
      loading.value = false;
    }
  };

  watch(() => unref(installmentId), load, { immediate: true });

  return {
    detail,
    loading,
    error,
    hasDetail: computed(() => Boolean(detail.value)),
    load,
  };
}
